/**
 * SoundType.js
 * Maps easy-to-use sound variables to the IDs that were given to each sound file in assets.json
 * 
 * Created on 15-oct-2013
 * 
 * @author Olivier van der Pool for Ranj
 * 
 **/

const SoundType = {
    SOUND_CLICK: "click"
};

export default SoundType;